import { render, staticRenderFns } from "./ViewingDiscipline.vue?vue&type=template&id=63cf9ceb"
import script from "./ViewingDiscipline.vue?vue&type=script&lang=js"
export * from "./ViewingDiscipline.vue?vue&type=script&lang=js"
import style0 from "./ViewingDiscipline.vue?vue&type=style&index=0&id=63cf9ceb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports